import React from 'react';
import classNames from 'classnames';
import proptypes from 'prop-types';
const { string, bool, arrayOf, oneOfType } = proptypes;
import { Typography } from '@one-thd/sui-atomic-components';

const KeyProductFeatureName = (props) => {
  const { name, simple, inverseText, responsiveTileGrid } = props;
  const keyProductFeatureNameClasses = classNames('sui-flex', {
    'sui-w-full': responsiveTileGrid,
    'sui-w-1/2': !responsiveTileGrid,
  });
  return (
    <>
      {simple || inverseText ? (
        <>
          <div className={keyProductFeatureNameClasses}>
            <Typography truncate variant="body-xs" color="subtle">{name}</Typography>
          </div>
        </>
      ) : (
        <Typography variant="h4">{name}</Typography>
      )}
    </>
  );
};

KeyProductFeatureName.propTypes = {
  name: oneOfType([string, arrayOf(string)]),
  simple: bool
};

KeyProductFeatureName.defaultProps = {
  name: null,
  simple: false,
  inverseText: false,
  responsiveTileGrid: false
};

export default KeyProductFeatureName;
